import React, { useState ,useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../common/Loader';
import AdminLayout from './AdminLayout';
import Table from '../common/Table';
import { ListManagementCost } from '../store/slices/management-cost.js';

const ListManagement = () => {
  

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = JSON.parse(localStorage.getItem('user'));
  const UserID = user?.data?.profile_id;
  const Name = user?.data?.company_name;

  const [units, setUnits] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [managementCostList, setManagementCostList] = useState([]);
  const tableRef = useRef(null);
  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const currentDate = new Date().toISOString().split('T')[0];
  const [errors, setErrors] = useState({});

  const fetchList = () => {
    if (!UserID) return;
    setIsLoading(true);
    dispatch(ListManagementCost({ profile_id: UserID }))
      .then((action) => {
        const res = action.payload || action;
        const list = res?.data || res?.result || res || [];
        const items = Array.isArray(list) ? list : list.data || [];
        setManagementCostList(items);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
    if (!item) return;
    navigate(`/management-cost/edit/${item.phase}`, { state: { phase: item.phase } });
  };

  const handleDelete = (item) => {
    // not implemented: only edit button required on this page
  };

  const handleSearchChange = (e) => setSearchQuery(e.target.value || '');

  const filtereditemList = managementCostList.filter((it) => {
    if (!searchQuery) return true;
    const s = searchQuery.toLowerCase();
    return (
      String(it.phase || '').toLowerCase().includes(s) ||
      String(it.total_amount || '').toLowerCase().includes(s) ||
      String(it.id || '').toLowerCase().includes(s)
    );
  });

  const columns = [
    { header: 'Sr No', field: 'sr_no' },
    { header: 'Phase', field: 'phase' },
    // { header: 'Total Amount', field: 'total_amount' },
    {
      header: 'Actions',
      field: 'actions',
      isAction: true,
      getActionButtons: () => [{ name: 'Edit', className: 'btn-default' }],
    },
  ];

  const normalizedList = (filtereditemList || []).map((item, idx) => ({
    ...item,
    sr_no: idx + 1,
  }));



  





  return (
    <AdminLayout>
        {isLoading && <Loader />}
          <div className="row content-body">
            <div className="container">
              <div className="page-header">
                <div>
                  <h2 className="main-content-title tx-24 mg-b-5">Management Cost</h2>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Registers</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                       Management Cost List
                    </li>
                  </ol>
                </div>
                <div className="d-flex justify-content-end">
                   <button className="btn ripple btn-default" onClick={() => navigate('/management-cost-head/list')}>
                       Cost Head
                  </button>
                  <button className="btn ripple btn-default" onClick={() => navigate('/management-cost/add')} >
                       Add Management Cost
                  </button>
                  <button class="btn btn-cancel"  onClick={() => navigate('/registers')} >Cancel</button>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <Table
                    columns={columns}
                    data={normalizedList}
                    tableRef={tableRef}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    currentPage={currentPage}
                    totalCount={filtereditemList?.length}
                    onPageChange={handlePageChange}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                    handleSearchChange={handleSearchChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </AdminLayout>
  );
};

export default ListManagement;
